@if (showToggleAllocation) {
<div>
  <button type="button" class="btn btn-primary btn-lg" [disabled]="!moduleIsEditable" (click)="toggleAllocationModule()">Allocate to this module</button>
</div>
} @else {
<div class="well-details-container">
  @if (showMultipleAssetMessage) {
  <div class="alert alert-danger">{{multipleAssetMessage}}</div>
  }
  <form novalidate [formGroup]="wellMapForm">
    <div class="flex-column">
      <div class="flex-row flex-100">
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>Type</label>
            <kendo-combobox class="form-control" formControlName="AssetType" [data]="filteredAssetTypeList" [textField]="'Description'"
              [valueField]="'AssetTypeId'" [placeholder]="'Select Asset Type...'" [disabledControl]="disabledAssetType" (valueChange)="handleAssetTypeSelectionChange($event)">
            </kendo-combobox>
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>Name</label>
            @if (!moduleIsEditable) {
            <input class="k-textbox form-control" readonly value="{{well?.AssetName}}">
            } @else {
            <kendo-combobox class="form-control" formControlName="Asset" [data]="assetNameList" [textField]="'AssetName'"
              [valueField]="'AssetId'" [placeholder]="'Select Asset...'" [disabledControl]="disabledAssets" [value]="well" [filterable]="true"
              (valueChange)="handelAssetNameSelectionChange($event)" (filterChange)="handleAssetFilter($event)">
            </kendo-combobox>
            }
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>Asset ID</label>
            @if (!moduleIsEditable) {
            <input class="k-textbox form-control" readonly value="{{well?.AssetId}}">
            } @else {
            <kendo-combobox class="form-control" formControlName="Asset" [data]="assetIdList" [textField]="'AssetId'"
              [valueField]="'AssetId'" [placeholder]="'Select Asset ID...'" [disabledControl]="disabledAssets" [value]="well" [filterable]="true"
              (valueChange)="handelAssetIdSelectionChange($event)" (filterChange)="handleAssetIdFilter($event)">
            </kendo-combobox>
            }
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>SSN</label>
            @if (!moduleIsEditable) {
            <input class="k-textbox form-control" readonly value="{{well?.Ssn}}">
            } @else {
            <kendo-combobox class="form-control" formControlName="Asset" [data]="wellSsnList" [textField]="'Ssn'"
              [valueField]="'AssetId'" [placeholder]="'Select Well SSN...'" [disabledControl]="disabledAssets" [value]="well" [filterable]="true"
              (valueChange)="handelWellSsnSelectionChange($event)" (filterChange)="handleWellSsnFilter($event)">
            </kendo-combobox>
            }
          </div>
        </div>
      </div>
      <div class="flex-row flex-100">
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>OWID</label>
            @if (!moduleIsEditable) {
            <input class="k-textbox form-control" readonly value="{{well?.OWID}}">
            } @else {
            <input id="Owid" class="k-textbox form-control" formControlName="Owid" placeholder="Enter OWID..." [attr.disabled]="!isOwidEditable ? '' : null">
            }
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>Cost Center ID</label>
            <input class="k-textbox form-control" readonly value="{{well?.CostCenterNumber}}">
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>Cost Center</label>
            <input class="k-textbox form-control" readonly value="{{well?.CostCenter}}">
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>Tank Battery Name</label>
            <input class="k-textbox form-control" readonly value="{{tankBattery?.AssetName}}">
          </div>
        </div>
      </div>
      <div class="flex-row flex-100">
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>Pad</label>
            <input class="k-textbox form-control" readonly [value]="getPadDescription()">
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>Formation</label>
            <input class="k-textbox form-control" readonly value="{{well?.TargetFormation}}">
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>Working Interest</label>
            <input class="k-textbox form-control" readonly value="{{ workingInterest | number: '1.7-7' }}">
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-row" style="padding-top: 28px;">
            <input type="checkbox" name="IsInsideCityLimits" id="IsInsideCityLimits" [(ngModel)]="isInsideCityLimits" [disabled]="'true'"
              [ngModelOptions]="{standalone: true}">
            <label for="IsInsideCityLimits" style="margin-left: 10px;line-height: 14px;">Inside City Limits</label>
          </div>
        </div>
      </div>
      <div class="flex-row flex-100">
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>County</label>
            <input class="k-textbox form-control" readonly value="{{well?.County}}">
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>State</label>
            <input class="k-textbox form-control" readonly value="{{well?.State}}">
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>Type Curve Area</label>
            <input class="k-textbox form-control" readonly value="{{well?.TypeCurveArea}}">
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
        </div>
      </div>
    </div>
  </form>
</div>
}